module.exports = __webpack_public_path__ + "static/media/order-calendar-right-arrow.15a6f4c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/order-calendar-right-arrow.svg
// module id = 377
// module chunks = 0